export const SERVICES = [
  { id: 1, title: "Opvask", icon: "Coffee" },
  { id: 2, title: "Kaffemaskiner", icon: "Coffee" },
  { id: 3, title: "Ovne", icon: "Flame" },
  { id: 4, title: "Isterninger", icon: "Snowflake" },
  { id: 5, title: "Køle/frys", icon: "Wind" },
  { id: 6, title: "Vandbehandling", icon: "Droplets" },
  { id: 15, title: "Drikkevandfilter & blødvandfilter", icon: "Filter" },
  { id: 7, title: "Køkkenudstyr", icon: "ChefHat" },
  { id: 8, title: "Komfur", icon: "Zap" },
  { id: 16, title: "Salg af knive og slibning af knive", icon: "Scissors" },
  { id: 17, title: "Damprensning af køkken", icon: "Droplets" },
  { id: 18, title: "Reparation af dampudstyr", icon: "Flame" },
  { id: 9, title: "Røremaskine", icon: "RotateCcw" },
  { id: 10, title: "Pålægsmaskine", icon: "Scissors" },
  { id: 11, title: "Grill", icon: "Flame" },
  { id: 12, title: "Friture", icon: "Thermometer" },
  { id: 13, title: "Rustfri", icon: "Shield" },
  { id: 14, title: "Brugt udstyr", icon: "RefreshCw" },
];

export const PARTNERS = [
  { name: "Partner 1", logo: "/imgi_1_logo-1.png" },
  { name: "Partner 2", logo: "/imgi_2_logo-2.png" },
  { name: "Partner 3", logo: "/imgi_3_logo-3.png" },
  { name: "Partner 4", logo: "/imgi_4_logo-5.png" },
  { name: "Partner 5", logo: "/imgi_5_logo-7.png" },
  { name: "Partner 6", logo: "/imgi_6_logo-8.png" },
  { name: "Partner 7", logo: "/imgi_7_logo-9.png" },
  { name: "Partner 8", logo: "/imgi_8_logo-10.png" },
  { name: "Partner 9", logo: "/imgi_9_logo-6.png" },
  { name: "Everpure", logo: "/imgi_10_everpure-logo.png" },
  { name: "Partner 10", logo: "https://assets.auxodev.dk/assets/67f7e0e4-1ea1-40d6-9984-2e6506bafd1f/image.png" },
  { name: "Fagor", logo: "https://assets.auxodev.dk/assets/67f7e0e4-1ea1-40d6-9984-2e6506bafd1f/logo-fagor-1.jpeg" }
];
